import { HttpClient, HttpParams } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@env/environment';
import {
  GetAllRequestResponse,
  GetSingleRequestResponse,
} from '@modules/regular-user/requests/domain';
import { API_ENDPOINTS } from '@typings/api-endpoints.type';
import { ApiQueryParams } from '@utils/api-query-params.type';
import { buildQueryParams } from '@utils/query';
import { map, Observable, of } from 'rxjs';

import {
  Approve,
  GetApprovalsCountResponse,
  GetApprovesResponse,
} from '../../domain/entities/approves.entity';
import { ApprovesServices } from '../../domain/services/approves.service';
import {
  AppUser,
  GetAllUsersResponse,
} from '@modules/company-manager/users/domain';

@Injectable()
export class ApprovesServicesImpl implements ApprovesServices {
  constructor(private client: HttpClient) {}

  getAllApproves(companyId: string): Observable<any> {
    const params = new HttpParams()
      .set('_companyId', companyId)
      .set('populate', 'action,requester,approver')
      .set(
        'deepPopulate',
        `{"path":"approver","populate":{"path":"_profilePicture"}}`
      );
    return this.client
      .get<GetAllRequestResponse>(
        environment.apiDomain + API_ENDPOINTS.REQUEST.GET_ALL(),
        { params }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  exportApproves(approves: Approve[]): Observable<any> {
    return of({
      data: [
        {
          message: 'Sucessfully exported',
        },
      ],
    });
  }

  getApproveById(approveId: string): Observable<GetSingleRequestResponse> {
    const params = new HttpParams()
      .set('populate', 'requester,approvals,action,comments')
      // .set('filter', `{"_id":"${approveId}"}`);
      .set(
        'deepPopulate',
        `{"path":"approvals","populate":{"path":"approver"}}`
      );

    return this.client
      .get<GetSingleRequestResponse>(
        environment.apiDomain +
          API_ENDPOINTS.REQUEST.REQUEST_DETAILS(approveId),
        {
          params,
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  approveARequest(
    requestId: string,
    message: string
  ): Observable<GetSingleRequestResponse> {
    const params = new HttpParams().set('populate', 'requester,_action');
    return this.client
      .put<GetSingleRequestResponse>(
        environment.apiDomain +
          API_ENDPOINTS.APPROVES.APPROVE_REQUEST(requestId),
        {
          content: message,
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  denyARequest(
    requestId: string,
    message: string
  ): Observable<GetSingleRequestResponse> {
    const params = new HttpParams().set('populate', 'requester,_action');
    return this.client
      .put<GetSingleRequestResponse>(
        environment.apiDomain + API_ENDPOINTS.APPROVES.DENY_REQUEST(requestId),
        {
          content: message,
        }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  myApproves(query: ApiQueryParams): Observable<GetAllRequestResponse> {
    const params = buildQueryParams(query);
    return this.client
      .get<GetAllRequestResponse>(
        environment.apiDomain + API_ENDPOINTS.REQUEST.GET_ALL(),
        { params }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }

  approvalsCount(query: ApiQueryParams): Observable<GetApprovalsCountResponse> {
    const params = buildQueryParams(query);
    return this.client
      .get<GetApprovalsCountResponse>(
        environment.apiDomain + API_ENDPOINTS.REQUEST.REQUESTS_COUNT(),
        { params }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  pendingApprovals(query: ApiQueryParams): Observable<GetApprovesResponse> {
    const params = buildQueryParams(query);
    return this.client
      .get<GetApprovesResponse>(
        environment.apiDomain + API_ENDPOINTS.REQUEST.GET_ALL(),
        { params }
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
  getApproversByCompany(companyId: string): Observable<GetApprovesResponse> {
    return this.client
      .get<GetApprovesResponse>(
        environment.apiDomain + API_ENDPOINTS.MY_COMPANY.GET_APPROVER()
      )
      .pipe(
        map((response) => {
          return response;
        })
      );
  }
}

/**
 * Request response example
 */

//  {
//       action: 'payment',
//       amount: 10,
//       description: 'this is a test',
//       urgent: true,
//       status: 'approved',
//       _requester: {
//         email: 'regularuser@checkplus.com',
//         firstName: 'regular-user',
//         lastName: 'regularuser',
//       },
//       _id: '62c7b5115a1a46f1c7d5b98b',
//       id: '62c7b5115a1a46f1c7d5b98b',
//     },
